import { render, staticRenderFns } from "./NewRightFloatingButton.vue?vue&type=template&id=6c6c626e&scoped=true&"
import script from "./NewRightFloatingButton.vue?vue&type=script&lang=js&"
export * from "./NewRightFloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./NewRightFloatingButton.vue?vue&type=style&index=0&id=6c6c626e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6c626e",
  null
  
)

export default component.exports